import axios from "axios";

const apiUrl = "https://nijigenexpo.com/wp-json/wc/v3/";
const consumerKey = "ck_52a69b88179a05de2cce711f4d3658b2a997be70";
const consumerSecret = "cs_6bae2f9d2ca6237e2daf5616cfa37af28aaa77e2";
export const axiosInstance = axios.create({
  baseURL: apiUrl,
  auth: {
    username: consumerKey,
    password: consumerSecret,
  },
});
